import { Select } from "@clintonelec/react-storybook";
import { encryptionTypeOptions, httpsAuthTypeOptions, rtspOptions } from "Data/Objects/NetworkSecurity";
import type { NetworkSecurityState, SecurityCertificate } from "Interfaces";
import { Fragment, memo } from "react";
import CertificateField from "Components/ConfigLayout/Network/SecuritySettings//CertificateField";

type EncryptionTabProps = {
	securitySettings: NetworkSecurityState;
	handleRtspAuthSelect: (value: string | null) => void;
	handleEncryptionTypeSelect: (newEncryptionType: string | null) => void;
	handleHttpAuthTypeSelect: (value: string | null) => void;
	handleSslCertificateUpdate: (certificate: SecurityCertificate) => void;
};

function EncryptionTab(props: EncryptionTabProps) {
	const {
		securitySettings, handleRtspAuthSelect, handleEncryptionTypeSelect, handleHttpAuthTypeSelect,
		handleSslCertificateUpdate: updateSslCertificate
	} = props;

	const certificateFields = securitySettings.sslCertificates.map((cert) => (
		<CertificateField
			key={ cert.type }
			ieeeEnabled
			certificate={ cert }
			handleCertUpdate={ updateSslCertificate }
		/>
	));

	return (
		<Fragment>
			<h4>Secure Connection</h4>
			<div className="form-row">
				<span>Encryption Type</span>
				<Select
					allowClear={ false }
					className="form-select"
					onSelect={ handleEncryptionTypeSelect }
					options={ encryptionTypeOptions }
					value={ securitySettings.securityOptions.encryptionType }
				/>
			</div>
			<div className="form-row">
				<span>HTTP Authentication Type</span>
				<Select
					allowClear={ false }
					className="form-select"
					name="httpAuthType"
					onSelect={ handleHttpAuthTypeSelect }
					options={ httpsAuthTypeOptions }
					value={ securitySettings.securityOptions.httpAuthType }
				/>
			</div>
			<div className="form-row">
				<span>RTSP Authentication Type</span>
				<Select
					allowClear={ false }
					className="form-select"
					name="authSelect"
					onSelect={ handleRtspAuthSelect }
					options={ rtspOptions }
					value={ securitySettings.securityOptions.rtspAuthType }
				/>
			</div>
			<h4>SSL Certificate</h4>
			{ certificateFields }
		</Fragment>
	);
}

export default memo(EncryptionTab);
